import { GameConstants } from "./GameConstants";
import { PreLoader } from "./states/Preloader";
import { GameState } from "./states/GameState";
import { Boot } from "./states/Boot";

export class Game extends Phaser.Game {

    constructor() {

        super(GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT, Phaser.AUTO, "content", null, false, true);

        this.state.add("PreLoader", PreLoader, false);
        this.state.add("GameState", GameState, false);

        if (GameConstants.SPONSOR === GameConstants.DICO) {
            if (location.hostname === "fungames4all.com" || location.hostname === "localhost") {
                this.state.add("Boot", Boot, true);
            } 
        } else {
            this.state.add("Boot", Boot, true);
        }
    }
}
